import { useCallback } from 'react';
import { useUpdateInsightsShowHiddenItemsMutation } from 'shared/hooks/queries/use-update-insights-show-hidden-items-mutation';

export const useToggleHiddenInsights = () => {
  const { mutate } = useUpdateInsightsShowHiddenItemsMutation();

  return useCallback((checked: boolean) => mutate(checked), [mutate]);
};
